var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4258 0.00195312C15.4559 0.00325174 15.486 0.00494093 15.5156 0.0107422C15.5423 0.0159279 15.5675 0.0255816 15.5928 0.0341797C15.6044 0.0381211 15.6166 0.0402526 15.6279 0.0449219C15.7389 0.0904442 15.8326 0.168167 15.8984 0.266602C15.905 0.276354 15.9101 0.28684 15.916 0.296875C15.9683 0.385867 16 0.488853 16 0.599609V5.03906C15.9997 5.37008 15.7315 5.63857 15.4004 5.63867C15.0694 5.63851 14.8001 5.37004 14.7998 5.03906V2.04785L9.53418 7.31445C9.42181 7.4267 9.26918 7.49009 9.11035 7.49023C8.95136 7.49023 8.79804 7.4268 8.68555 7.31445L5.40918 4.03809L1.02344 8.4248C0.789306 8.65828 0.409949 8.65823 0.175781 8.4248C-0.0584857 8.19054 -0.0583781 7.8105 0.175781 7.57617L4.98535 2.76562L5.07715 2.69043C5.17495 2.62528 5.29091 2.58984 5.41016 2.58984C5.56912 2.58997 5.72157 2.65321 5.83398 2.76562L9.10938 6.04102L13.9521 1.19922H10.9609C10.6299 1.19906 10.3616 0.930675 10.3613 0.599609C10.3613 0.268336 10.6297 0.000157545 10.9609 0H15.4004C15.4088 2.53354e-06 15.4174 0.00160643 15.4258 0.00195312Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrending);
export default __webpack_public_path__ + "static/media/trending.f5d835fb091e11c8d32b53c47693ab86.svg";
export { ForwardRef as ReactComponent };